import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useSignupDialog } from "@/contexts/SignupDialogContext";
import { useSiteSetting } from "@/hooks/useSiteSettings";

const CTASection = () => {
  const { openSignupDialog } = useSignupDialog();
  const { data: registrationDisabled } = useSiteSetting("registration_disabled");
  return (
    <section className="py-6 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-secondary to-accent opacity-10" />
      <div className="container px-4 relative z-10">
        <motion.div
          className="max-w-3xl mx-auto text-center bg-card md:bg-transparent border border-border/60 md:border-0 rounded-2xl md:rounded-none p-6 md:p-0 mx-2 md:mx-auto shadow-card md:shadow-none"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display text-2xl md:text-6xl font-bold mb-4 md:mb-6">
            Ready to Join the <span className="gradient-text">Revolution?</span>
          </h2>
          <p className="text-muted-foreground text-sm md:text-lg mb-6 md:mb-10 max-w-xl mx-auto">
            Join millions of users already connecting, selling, creating, and growing on Gloogum.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="hero"
              size="lg"
              className="px-10 py-6 text-base md:text-lg rounded-full md:rounded-md w-full sm:w-auto"
              onClick={openSignupDialog}
              disabled={registrationDisabled}
              title={registrationDisabled ? "Registration is temporarily disabled" : undefined}
            >
              {registrationDisabled ? "Registration disabled" : "Create Your Account"} <ArrowRight className="ml-2" />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
